module.exports = __webpack_public_path__ + "static/media/close.85e1d01e.svg";